// extracted by mini-css-extract-plugin
module.exports = {"text":"style_text_3BUuY"};